/* eslint-disable jira/filename-case */
import type { ComponentType } from 'react';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { ContentProps } from './index.tsx';

const CreateSamplePlanContent: LazyComponent<ComponentType<ContentProps>> = lazyForPaint<
	ComponentType<ContentProps>
>(() =>
	import(/* webpackChunkName: "async-portfolio-3-create-sample-plan" */ './index.tsx').then(
		(module) => module.default,
	),
);

export const preloadCreateSamplePlanContent = (): void => {
	CreateSamplePlanContent.preload();
};

export default CreateSamplePlanContent;
